let $players = $('.js-audio'),
	activeTrack;

function pad(num, size) {
	var s = num + '';
	while (s.length < size) s = '0' + s;
	return s;
}

function getClickpos(e) {
	return e.offsetX == undefined ? e.layerX : e.offsetX || 0.0001;
}

$players.each(function() {
	let $player = $(this),
		$play = $player.find('.js-audio-play'),
		$prev = $player.find('.js-audio-prev'),
		$next = $player.find('.js-audio-next'),
		$volume = $player.find('.js-audio-volume'),
		audio = new Audio(),
		$playlist = $player.find('.js-audio-tracks'),
		tracks = $playlist[0].querySelectorAll('a'),
		current = 0,
		length = tracks.length,
		isPlaying = false,
		$progress = $('.js-audio-progress'),
		$progressBar = $progress.find('div'),
		$name = $player.find('.js-audio-name'),
		$time = $player.find('.js-audio-time');
	audio.volume = 1;


	if (tracks.length < 1) {
		return;
	}

	run(tracks[current], audio);

	$play.on('click', function() {
		if (isPlaying) {
			isPlaying = false;
			audio.pause();
			return;
		}
		audio.play();
		isPlaying = true;
	});
	$(audio).on('timeupdate', function() {
		let ct = audio.currentTime,
			dur = audio.duration || 0.00001,
			progress = Math.round(100 / dur * ct) + '%';
		$progressBar.width(progress);
	});
	$progress.on('click', function(e) {
		let x = getClickpos(e);
		let progress = $progress.width();
		progress = x / progress * 100;
		audio.currentTime = audio.duration / 100 * progress;
	});
	$(audio).on('play',function() {
		$play.removeClass('us-paused');
	});
	$(audio).on('pause',function() {
		$play.addClass('us-paused');
	});
	$player.on('click', '.js-audio-next', function() {
		if (current < length - 1) {
			current++;
			run(tracks[current], audio);
			audio.play();
			isPlaying = true;
		}
	});

	$player.on('click', '.js-audio-prev', function() {
		let link;
		if (current > 0) {
			current--;
			run(tracks[current], audio);
			audio.play();
			isPlaying = true;
		}
	});
	$(audio).on('ended', function(e) {
		$next.click();
	});
	$(audio).on('loadedmetadata', function(e) {
		let time;

		if (!!audio.duration) {
			time = Math.floor(+audio.duration / 60) + ':' + pad(Math.floor(+audio.duration % 60), 2);
		} else {
			time = '00:00';
		}
		// player.play();
		$time.text(time);
	});
	$volume.on('click', (e) => {
		let x = getClickpos(e);
		let $dots = $volume.find('span');
		$dots.removeClass('us-active');
		let volume = $volume.width();
		volume = 100 / volume * x;
		audio.volume = volume / 100;
		let steps = Math.floor(volume/20);
		for (let i = 0; i <= steps; i++) {
			$dots.eq(i).addClass('us-active');
		}

	});

	function run(link, player) {
		link = $(link);
		$name.html(`<span title='${link.data('name')}'>${current + 1}/${length} — ${link.data('name')}</span>`);
		audio.src = link.attr('href');
		audio.load();

	}
});
